import { createQueryData } from '../helpers/createQueryData';

const { useQuery } = createQueryData({
  endPoint: 'Acceptance/company/{id}/workers',
  options: {
    createParams: ({ endPoint, params }) => {
      const { companyId } = params;
      return { url: endPoint.replace('{id}', companyId) };
    },
  },
});

const useWorkersQuery = ({ params: { companyId } = {}, options } = {}) =>
  useQuery({
    params: { companyId },
    options: { enabled: Boolean(companyId), ...options },
  });

export { useWorkersQuery };
